import { LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { unsafeSVG } from 'lit/directives/unsafe-svg.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { style } from './qr-code.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { UNIVERSAL_QR_CODE, type UQR } from './uqr.js'

@customElement('cse-qr-code')
export class CSEQrCode extends LitElement {
  static override styles = [hostStyle, style]

  @property({ attribute: 'data', reflect: true })
  data = ''

  @inject(UNIVERSAL_QR_CODE)
  qrRenderer!: UQR

  override async connectedCallback() {
    await this.qrRenderer.initialize()

    super.connectedCallback()
  }
  override render() {
    return this.data ? unsafeSVG(this.qrRenderer.renderSVG(this.data, { border: 0 })) : nothing
  }
}
